import React from "react";

const SingleReferenceLogo= ({ data, sliderClass }) => {
  return (
    <li
      className={`text-center ${sliderClass && sliderClass ? sliderClass : ""}`}
    >
      <a
        href={process.env.PUBLIC_URL + data.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={process.env.PUBLIC_URL + data.image} alt="brand images" />
      </a>
    </li>
  );
};


export default SingleReferenceLogo;
